import Moveable from 'moveable';
import { getInstance } from '../../services/animation';
import { hideActiveElementToolbar, showActiveElementToolbar } from './ActiveElementToolbar/ActiveElementToolbar.svelte';
import { createComponent } from './Component';
import editorInstance from './editor';
import './editor.store';
import './helpers';
import { getEditorModules } from './modules';
let activeComponent;
const reactivityHook = (obj, triggers) => {
    const modules = getEditorModules(obj);
    modules.forEach(m => {
        triggers.forEach(trigger => {
            if (m[trigger]) {
                const fn = m[trigger];
                if (typeof fn === 'function')
                    fn(obj);
            }
        });
    });
};
const onStartMovement = (obj) => {
    // editorStore.startEditting();
    const animationService = getInstance();
    animationService.pause();
    hideActiveElementToolbar();
    // reactivityHook(obj, ["onMoveStart"]);
};
const onEndMovement = (obj) => {
    const animationService = getInstance();
    animationService.quickBuildAnimations();
    editorInstance.history.addHistory('Move');
    showActiveElementToolbar();
};
const defaultReactivityOptions = {
    draggable: true,
    resizable: true,
    rotatable: false,
    clippable: false,
    defaultClipPath: 'inset',
    customClipPath: '',
    clipRelative: false,
    clipArea: false,
    dragWithClip: true,
    snappable: true,
    keepRatio: true
};
export default class Reactivity {
    static isLocked = false;
    static targetParent = document.querySelector('#conatinerArea');
    static currentTarget;
    static keyboardDownEventBindingFn;
    static keyboardUpEventBindingFn;
    static makeUnreactive(moveable) {
        window.removeEventListener('keydown', this.keyboardDownEventBindingFn);
        if (this.keyboardUpEventBindingFn)
            window.removeEventListener('keyup', this.keyboardUpEventBindingFn);
        moveable.destroy();
    }
    static makeReactive(obj, e, customReactivityOptions = {}) {
        let reactivityOptions = { ...defaultReactivityOptions, ...customReactivityOptions };
        if (obj.classList.contains('unreactive-element'))
            return;
        const targetParent = document.querySelector('#containerArea');
        if (!targetParent)
            throw 'Unable to identify target parent for reactivity. please set it to a new HTML Component';
        if (!obj)
            throw 'Unable to make reactive. Please provide a valid object';
        const component = createComponent(obj);
        if (component && component.reactivityOptions)
            reactivityOptions = {
                ...reactivityOptions,
                ...component.reactivityOptions
            };
        const moveable = new Moveable(targetParent, {
            target: obj,
            useResizeObserver: true,
            ...reactivityOptions
        });
        if (e)
            moveable.dragStart(e);
        const optionsMap = {
            draggable: this.makeDraggable.bind(this),
            resizable: this.makeResizeable.bind(this),
            rotatable: this.makeRotatable.bind(this),
            clippable: this.makeClippable.bind(this),
            snappable: this.makeSnappable.bind(this)
        };
        this.currentTarget = obj;
        Object.keys(reactivityOptions).forEach((key) => {
            //@ts-ignore
            const option = optionsMap[key];
            if (option)
                option(moveable);
        });
        const keydownEventBinding = (event) => {
            if (event.key == 'Shift') {
                moveable.keepRatio = false;
            }
            const keyupEvent = (event) => {
                if (event.key == 'Shift') {
                    moveable.keepRatio = true;
                }
                window.removeEventListener('keyup', keyupEvent);
                this.keyboardUpEventBindingFn = null;
            };
            this.keyboardUpEventBindingFn = keyupEvent;
            window.addEventListener('keyup', keyupEvent);
        };
        this.keyboardDownEventBindingFn = keydownEventBinding;
        window.addEventListener('keydown', this.keyboardDownEventBindingFn);
        return moveable;
    }
    static makeSnappable(moveable) {
        moveable.elementSnapDirections = {
            left: true,
            top: true,
            right: true,
            bottom: true,
            center: true,
            middle: true
        };
        moveable.elementGuidelines = [...document.querySelectorAll('.stampElem, .shapeOuter, #finalImageToExport')];
    }
    static makeDraggable(moveable) {
        let original;
        let final = null;
        const finalTarget = this.currentTarget;
        let originalTransform = '';
        moveable
            .on('drag', ({ target, transform, left, top }) => {
            // target.style.transform = transform;
            target.style.left = left + 'px';
            target.style.top = top + 'px';
            final = [left, top];
        })
            .on('dragStart', ({ target, clientX, clientY }) => {
            originalTransform = target.style.transform;
            onStartMovement(finalTarget);
            reactivityHook(this.currentTarget, ['onMoveStart']);
        })
            .on('dragEnd', data => {
            if (!final)
                return;
            this.currentTarget.setAttribute('data-origtop', final[1].toString());
            this.currentTarget.setAttribute('data-origleft', final[0].toString());
            setTimeout(() => {
                onEndMovement(finalTarget);
                reactivityHook(this.currentTarget, ['onMove']);
            }, 50);
        });
    }
    static makeClippable(moveable) {
        moveable
            .on('clipStart', e => {
            // console.log(e);
        })
            .on('clip', e => {
            if (e.clipType === 'rect') {
                e.target.style.clip = e.clipStyle;
            }
            else {
                e.target.style.clipPath = e.clipStyle;
            }
        })
            .on('clipEnd', e => {
            // console.log(e);
        });
    }
    static makeResizeable(moveable) {
        let end;
        let finalTranslate;
        let originalTransform = '';
        const finalTarget = this.currentTarget;
        let skipTranslate = false;
        /* resizable */
        moveable
            .on('resize', ({ target, drag, width, height, transform }) => {
            const beforeTranslate = drag.beforeTranslate;
            if (width < 10 || height < 10)
                return (skipTranslate = true);
            target.style.width = `${width}px`;
            target.style.height = `${height}px`;
            target.style.transform = transform;
            finalTranslate = beforeTranslate;
        })
            .on('resizeStart', ({ target }) => {
            skipTranslate = false;
            originalTransform = target.style.transform;
            onStartMovement(finalTarget);
            reactivityHook(this.currentTarget, ['onResizeStart']);
        })
            .on('resizeEnd', ({ target }) => {
            if (skipTranslate)
                return;
            const [y, x] = finalTranslate;
            let top = Number.parseFloat(target.style.top);
            let left = Number.parseFloat(target.style.left);
            top += x;
            left += y;
            target.style.transform = originalTransform;
            target.style.top = top + 'px';
            target.style.left = left + 'px';
            target.setAttribute('data-origtop', top.toString());
            target.setAttribute('data-origleft', left.toString());
            onEndMovement(finalTarget);
            reactivityHook(this.currentTarget, ['onResize']);
        });
    }
    static makeRotatable(moveable) {
        const finalTarget = this.currentTarget;
        moveable
            .on('rotateStart', ({ target, clientX, clientY }) => {
            // console.log('onRotateStart', target);
        })
            .on('rotate', ({ target, beforeDelta, delta, dist, transform, clientX, clientY }) => {
            // console.log('onRotate', transform);
            target.style.transform = transform;
        })
            .on('rotateEnd', ({ target, isDrag, clientX, clientY }) => {
            onEndMovement(finalTarget);
        });
    }
}
